module.exports = __webpack_public_path__ + "static/media/awkward.d4965c04.png";